import { render } from "./ImageTextCard.vue?vue&type=template&id=3a1d74da"
import script from "./ImageTextCard.vue?vue&type=script&lang=js"
export * from "./ImageTextCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__